var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDropdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8619 0.861923L11.8047 1.80473L6 7.60947L0.195267 1.80473L1.13808 0.861923L6 5.72385L10.8619 0.861923Z",
  fill: "#636766"
})));
export { SvgDropdown as ReactComponent };
export default __webpack_public_path__ + "a85db3773ac1da71948c17989d1bb2a9.svg";